import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

interface UtilityPasswordProps extends InputComponentProps {
  utilityName?: string;
}

export const UtilityPassword = ({ utilityName, ...props }: UtilityPasswordProps) => {
  const validate = ({ value }) => {
    if (!value.length) return 'Please enter a password';
    return true;
  };

  return (
    <ValidatingInput
      autoComplete="current-password"
      label={utilityName ? `Password for ${utilityName}` : 'Password'}
      name="utilityPassword"
      placeholder="Enter your password"
      type="password"
      validate={validate}
      {...props}
    />
  );
};
